import { FunctionComponent } from "react";

interface GeneralTermsProps {}

const GeneralTerms: FunctionComponent<GeneralTermsProps> = () => {
  return (
    <main className="mx-auto mt-[85px] flex w-full flex-col items-start justify-start px-4 pb-16 lg:w-1/3 lg:px-0">
      <header className="w-full py-6 text-left">
        <h1 className="font-GeistBold text-3xl">
          Allgemeine Geschäftsbedingungen und Kundeninformationen
        </h1>
      </header>

      <hr className="mb-8 h-[1px] w-full border-0 bg-slate-300" />

      <div className="flex w-full flex-col items-start justify-start gap-10 text-base leading-relaxed">
        <section className="flex w-full flex-col gap-4">
          <h2 className="font-GeistBold text-2xl">
            I. Allgemeine Geschäftsbedingungen
          </h2>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              § 1 Grundlegende Bestimmungen
            </h3>

            <p>
              (1) Die nachstehenden Geschäftsbedingungen gelten für Verträge,
              die Sie mit uns als Anbieter (Juwelier Bucher GbR) über die
              Internetseite{" "}
              <a
                href="https://www.juwelier-bucher.de"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-2"
              >
                www.juwelier-bucher.de
              </a>{" "}
              schließen. Soweit nicht anders vereinbart, wird der Einbeziehung
              gegebenenfalls von Ihnen verwendeter eigener Bedingungen
              widersprochen.
            </p>

            <p>
              (2) Verbraucher im Sinne der nachstehenden Regelungen ist jede
              natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt,
              die überwiegend weder ihrer gewerblichen noch ihrer selbständigen
              beruflichen Tätigkeit zugerechnet werden kann. Unternehmer ist
              jede natürliche oder juristische Person oder eine rechtsfähige
              Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in
              Ausübung ihrer selbständigen beruflichen oder gewerblichen
              Tätigkeit handelt.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              § 2 Zustandekommen des Vertrages
            </h3>

            <p>(1) Gegenstand des Vertrages ist der Verkauf von Waren.</p>

            <p>
              (2) Bereits mit dem Einstellen des jeweiligen Produkts auf unserer
              Internetseite unterbreiten wir Ihnen ein verbindliches Angebot zum
              Abschluss eines Vertrages über das Online-Warenkorbsystem zu den
              in der Artikelbeschreibung angegebenen Bedingungen.
            </p>

            <div className="flex flex-col gap-4">
              <p>
                (3) Der Vertrag kommt über das Online-Warenkorbsystem wie folgt
                zustande:
              </p>

              <p>
                Die zum Kauf beabsichtigten Waren werden im
                &quot;Warenkorb&quot; abgelegt. Über die entsprechende
                Schaltfläche in der Navigationsleiste können Sie den
                &quot;Warenkorb&quot; aufrufen und dort jederzeit Änderungen
                vornehmen.
              </p>

              <p>
                Nach Anklicken der Schaltfläche &quot;Kasse&quot; oder
                &quot;Weiter zur Bestellung&quot; (oder ähnliche Bezeichnung)
                und der Eingabe der persönlichen Daten sowie der Zahlungs- und
                Versandbedingungen werden Ihnen abschließend die Bestelldaten
                als Bestellübersicht angezeigt.
              </p>

              <p>
                Soweit Sie als Zahlungsart ein Sofortzahl-System (z. B. PayPal
                (Express/Plus/Checkout), Amazon Pay, Sofort) nutzen, werden Sie
                entweder auf die Bestellübersichtsseite in unserem Online-Shop
                geführt oder auf die Internetseite des Anbieters des
                Sofortzahl-Systems weitergeleitet.
              </p>

              <p>
                Erfolgt eine Weiterleitung zu dem jeweiligen Sofortzahl-System,
                nehmen Sie dort die entsprechende Auswahl bzw. Eingabe Ihrer
                Daten vor. Abschließend werden Ihnen auf der Internetseite des
                Anbieters des Sofortzahl-Systems oder nachdem Sie zurück in
                unseren Online-Shop geleitet wurden, die Bestelldaten als
                Bestellübersicht angezeigt.
              </p>

              <p>
                Vor Absenden der Bestellung haben Sie die Möglichkeit, die
                Angaben in der Bestellübersicht nochmals zu überprüfen, zu
                ändern (auch über die Funktion &quot;zurück&quot; des
                Internetbrowsers) bzw. die Bestellung abzubrechen.
              </p>

              <p>
                Mit dem Absenden der Bestellung über die entsprechende
                Schaltfläche (&quot;zahlungspflichtig bestellen&quot;,
                &quot;kaufen&quot; / &quot;jetzt kaufen&quot;,
                &quot;kostenpflichtig bestellen&quot;, &quot;bezahlen&quot; /
                &quot;jetzt bezahlen&quot; oder ähnliche Bezeichnung) erklären
                Sie rechtsverbindlich die Annahme des Angebotes, wodurch der
                Vertrag zustande kommt.
              </p>
            </div>

            <p>
              (4) Ihre Anfragen zur Erstellung eines Angebotes sind für Sie
              unverbindlich. Wir unterbreiten Ihnen hierzu ein verbindliches
              Angebot in Textform (z. B. per E-Mail), welches Sie innerhalb von
              5 Tagen (soweit im jeweiligen Angebot keine andere Frist
              ausgewiesen ist) annehmen können.
            </p>

            <p>
              (5) Die Abwicklung der Bestellung und Übermittlung aller im
              Zusammenhang mit dem Vertragsschluss erforderlichen Informationen
              erfolgt per E-Mail zum Teil automatisiert. Sie haben deshalb
              sicherzustellen, dass die von Ihnen bei uns hinterlegte
              E-Mail-Adresse zutreffend ist, der Empfang der E-Mails technisch
              sichergestellt und insbesondere nicht durch SPAM-Filter verhindert
              wird.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              § 3 Besondere Vereinbarungen zu angebotenen Zahlungsarten
            </h3>

            <div className="flex flex-col gap-4">
              <h4 className="font-GeistBold text-lg">
                (1) Zahlung über &quot;PayPal&quot; / &quot;PayPal
                Checkout&quot;
              </h4>

              <p>
                Bei Auswahl einer Zahlungsart, die über &quot;PayPal&quot; /
                &quot;PayPal Checkout&quot; angeboten wird, erfolgt die
                Zahlungsabwicklung über den Zahlungsdienstleister PayPal
                (Europe) S.à.r.l. et Cie, S.C.A. (22-24 Boulevard Royal L-2449,
                Luxemburg; &quot;PayPal&quot;). Die einzelnen Zahlungsarten über
                &quot;PayPal&quot; werden Ihnen unter einer entsprechend
                bezeichneten Schaltfläche auf unserer Internetpräsenz sowie im
                Online-Bestellvorgang angezeigt. Für die Zahlungsabwicklung kann
                sich &quot;PayPal&quot; weiterer Zahlungsdienste bedienen;
                soweit hierfür besondere Zahlungsbedingungen gelten, werden Sie
                auf diese gesondert hingewiesen. Nähere Informationen zu
                &quot;PayPal&quot; finden Sie unter{" "}
                <a
                  href="https://www.paypal.com/de/webapps/mpp/ua/legalhub-full"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="break-words underline underline-offset-2"
                >
                  https://www.paypal.com/de/webapps/mpp/ua/legalhub-full
                </a>
                .
              </p>
            </div>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              § 4 Zurückbehaltungsrecht, Eigentumsvorbehalt
            </h3>

            <p>
              (1) Ein Zurückbehaltungsrecht können Sie nur ausüben, soweit es
              sich um Forderungen aus demselben Vertragsverhältnis handelt.
            </p>

            <p>
              (2) Die Ware bleibt bis zur vollständigen Zahlung des Kaufpreises
              unser Eigentum.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">§ 5 Gewährleistung</h3>

            <p>(1) Es bestehen die gesetzlichen Mängelhaftungsrechte.</p>

            <p>
              (2) Als Verbraucher werden Sie gebeten, die Ware bei Lieferung
              umgehend auf Vollständigkeit, offensichtliche Mängel und
              Transportschäden zu überprüfen und uns sowie dem Spediteur
              Beanstandungen schnellstmöglich mitzuteilen. Kommen Sie dem nicht
              nach, hat dies keine Auswirkung auf Ihre gesetzlichen
              Gewährleistungsansprüche.
            </p>

            <p>
              (3) Soweit ein Merkmal der Ware von den objektiven Anforderungen
              abweicht, gilt die Abweichung nur dann als vereinbart, wenn Sie
              vor Abgabe der Vertragserklärung durch uns über selbige in
              Kenntnis gesetzt wurden und die Abweichung ausdrücklich und
              gesondert zwischen den Vertragsparteien vereinbart wurde.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">§ 6 Rechtswahl</h3>

            <p>
              (1) Es gilt deutsches Recht. Bei Verbrauchern gilt diese
              Rechtswahl nur, soweit hierdurch der durch zwingende Bestimmungen
              des Rechts des Staates des gewöhnlichen Aufenthaltes des
              Verbrauchers gewährte Schutz nicht entzogen wird
              (Günstigkeitsprinzip).
            </p>

            <p>
              (2) Die Bestimmungen des UN-Kaufrechts finden ausdrücklich keine
              Anwendung.
            </p>
          </section>
        </section>

        <hr className="h-[1px] w-full border-0 bg-slate-300" />

        <section className="flex w-full flex-col gap-6">
          <h2 className="font-GeistBold text-2xl">II. Kundeninformationen</h2>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              1. Identität des Verkäufers
            </h3>

            <address className="not-italic">
              <p>Juwelier Bucher GbR</p>
              <p>Weinholdstraße 33</p>
              <p>08468 Reichenbach</p>
              <p>Deutschland</p>

              <p className="mt-4">
                Telefon:{" "}
                <a
                  href="tel:+49376512802"
                  className="underline underline-offset-2"
                >
                  0 37 65/ 1 28 02
                </a>
              </p>

              <p>
                E-Mail:{" "}
                <a
                  href="mailto:info@juwelier-bucher.de"
                  className="underline underline-offset-2"
                >
                  info@juwelier-bucher.de
                </a>
              </p>
            </address>

            <p>
              Wir sind nicht bereit und nicht verpflichtet, an
              Streitbeilegungsverfahren vor Verbraucherschlichtungsstellen
              teilzunehmen.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              2. Informationen zum Zustandekommen des Vertrages
            </h3>

            <p>
              Die technischen Schritte zum Vertragsschluss, der Vertragsschluss
              selbst und die Korrekturmöglichkeiten erfolgen nach Maßgabe der
              Regelungen &quot;Zustandekommen des Vertrages&quot; unserer
              Allgemeinen Geschäftsbedingungen (Teil I.).
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              3. Vertragssprache, Vertragstextspeicherung
            </h3>

            <p>3.1. Vertragssprache ist deutsch.</p>

            <p>
              3.2. Der vollständige Vertragstext wird von uns nicht gespeichert.
              Vor Absenden der Bestellung über das Online-Warenkorbsystem können
              die Vertragsdaten über die Druckfunktion des Browsers ausgedruckt
              oder elektronisch gesichert werden. Nach Zugang der Bestellung bei
              uns werden die Bestelldaten, die gesetzlich vorgeschriebenen
              Informationen bei Fernabsatzverträgen und die Allgemeinen
              Geschäftsbedingungen nochmals per E-Mail an Sie übersandt.
            </p>

            <p>
              3.3. Bei Angebotsanfragen außerhalb des Online-Warenkorbsystems
              erhalten Sie alle Vertragsdaten im Rahmen eines verbindlichen
              Angebotes in Textform übersandt, z. B. per E-Mail, welche Sie
              ausdrucken oder elektronisch sichern können.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">4. Verhaltenskodizes</h3>

            <p>
              4.1. Wir haben uns den Käufersiegel-Qualitätskriterien der
              Händlerbund Management AG unterworfen, einsehbar unter:{" "}
              <a
                href="https://www.haendlerbund.de/de/downloads/kaeufersiegel/kaeufersiegel-zertifizierungskriterien.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="break-words underline underline-offset-2"
              >
                https://www.haendlerbund.de/de/downloads/kaeufersiegel/kaeufersiegel-zertifizierungskriterien.pdf
              </a>
              .
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              5. Wesentliche Merkmale der Ware oder Dienstleistung
            </h3>

            <p>
              Die wesentlichen Merkmale der Ware und/oder Dienstleistung finden
              sich im jeweiligen Angebot.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              6. Preise und Zahlungsmodalitäten
            </h3>

            <p>
              6.1. Die in den jeweiligen Angeboten angeführten Preise sowie die
              Versandkosten stellen Gesamtpreise dar. Sie beinhalten alle
              Preisbestandteile einschließlich aller anfallenden Steuern.
            </p>

            <p>6.2. Es fallen keine Versandkosten an.</p>

            <p>
              6.3. Die Ihnen zur Verfügung stehenden Zahlungsarten sind unter
              einer entsprechend bezeichneten Schaltfläche auf unserer
              Internetpräsenz oder im jeweiligen Angebot ausgewiesen.
            </p>

            <p>
              6.4. Soweit bei den einzelnen Zahlungsarten nicht anders
              angegeben, sind die Zahlungsansprüche aus dem geschlossenen
              Vertrag sofort zur Zahlung fällig.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">7. Lieferbedingungen</h3>

            <p>
              7.1. Die Lieferbedingungen, der Liefertermin sowie gegebenenfalls
              bestehende Lieferbeschränkungen finden sich unter einer
              entsprechend bezeichneten Schaltfläche auf unserer Internetpräsenz
              oder im jeweiligen Angebot.
            </p>

            <p>
              7.2. Soweit Sie Verbraucher sind, ist gesetzlich geregelt, dass
              die Gefahr des zufälligen Untergangs und der zufälligen
              Verschlechterung der verkauften Sache während der Versendung erst
              mit der Übergabe der Ware an Sie übergeht, unabhängig davon, ob
              die Versendung versichert oder unversichert erfolgt. Dies gilt
              nicht, wenn Sie eigenständig ein nicht vom Unternehmer benanntes
              Transportunternehmen oder eine sonst zur Ausführung der Versendung
              bestimmte Person beauftragt haben.
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <h3 className="font-GeistBold text-xl">
              8. Gesetzliches Mängelhaftungsrecht
            </h3>

            <p>
              Die Mängelhaftung richtet sich nach der Regelung
              &quot;Gewährleistung&quot; in unseren Allgemeinen
              Geschäftsbedingungen (Teil I).
            </p>
          </section>

          <section className="flex flex-col gap-4">
            <p>
              Diese AGB und Kundeninformationen wurden von den auf IT-Recht
              spezialisierten Juristen des Händlerbundes erstellt und werden
              permanent auf Rechtskonformität geprüft. Die Händlerbund
              Management AG garantiert für die Rechtssicherheit der Texte und
              haftet im Falle von Abmahnungen. Nähere Informationen dazu finden
              Sie unter:{" "}
              <a
                href="https://www.haendlerbund.de/de/leistungen/rechtssicherheit/agb-service"
                target="_blank"
                rel="noopener noreferrer"
                className="break-words underline underline-offset-2"
              >
                https://www.haendlerbund.de/de/leistungen/rechtssicherheit/agb-service
              </a>
              .
            </p>
          </section>
        </section>
      </div>
    </main>
  );
};

export default GeneralTerms;
